
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.763","height":"14.041"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19837","data-name":"Path 19837","d":"M932.2 1106.109a1.107 1.107 0 01-1.1-1.287l.649-3.7-2.725-2.637a1.1 1.1 0 01-.008-1.571 1.215 1.215 0 01.612-.31l3.752-.545 1.693-3.373a1.109 1.109 0 011.493-.5 1.137 1.137 0 01.5.493v.007l1.668 3.354 3.759.56a1.112 1.112 0 01.731.425 1.092 1.092 0 01-.12 1.467l-2.7 2.611.642 3.714a1.115 1.115 0 01-.915 1.27 1.171 1.171 0 01-.7-.107l-3.337-1.748-3.383 1.753a1.149 1.149 0 01-.511.124zm3.882-2.964a1.1 1.1 0 01.527.134l3.318 1.739-.59-3.706a1.081 1.081 0 01.324-.991l2.7-2.611-3.754-.58a1.119 1.119 0 01-.839-.61l-1.664-3.348a.052.052 0 00-.02-.019l-1.712 3.366a1.134 1.134 0 01-.831.608l-3.741.543 2.692 2.652a1.11 1.11 0 01.32.986l-.648 3.694 3.4-1.727a1.077 1.077 0 01.514-.13z","transform":"translate(-928.688 -1092.068)","fill":"#5f6368"}})])
          )
        }
      }
    